import React from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Main from '../MainLayouts/Main'
import Container from '../GeneralComponents/Container'

const ReferralTerms = () => {
  return (
    <Main>
      <Box
        position={'relative'}
        display={'flex'}
        alignItems={'center'}
        justifyContent={'flex-start'}
        height={1}
        marginTop={-12}
        paddingTop={12}
      >
        <Container>
          <Grid container>
            <Grid
              item
              container
              alignItems={'center'}
              justifyContent={'flex-start'}
              xs={12}
              md={12}
            />
            <Box>
              <h1>Drivolo Referral Program – Terms &amp; Conditions</h1>
              <p>
                Welcome to the Drivolo Referral Program. By participating in
                this program, you agree to the following terms and conditions:
              </p>

              <h2>1. Eligibility</h2>
              <ul>
                <li>The referral program is open to all registered users of Drivolo.</li>
                <li>Participants must have an active Drivolo account.</li>
              </ul>

              <h2>2. Referral Reward Structure</h2>
              <ul>
                <li>Users can earn rewards by referring Drivolo to driving schools.</li>
                <li>A reward of ₹250 will be credited for each successful referral to both the referrer and the referred driving school.</li>
              </ul>

              <h2>3. Conditions for Successful Referral</h2>
              <p>A referral will be considered successful only when:</p>
              <ul>
                <li>The referred driving school signs up on Drivolo using the referral link/code.</li>
                <li>The driving school adds a minimum of 5 students to the platform.</li>
                <li>The added student data must be valid and verified.</li>
              </ul>

              <h2>4. Reward Disbursement</h2>
              <ul>
                <li>The ₹250 reward will be credited only after all referral conditions are fulfilled.</li>
                <li>Rewards may be credited to the user&apos;s wallet, bank account, or as per Drivolo&apos;s payment policy.</li>
                <li>Processing time for rewards may take up to 7–14 business days.</li>
              </ul>

              <h2>5. Fraud &amp; Misuse Policy</h2>
              <p>
                Any fraudulent activity (fake signups, duplicate accounts,
                invalid student entries) will lead to:
              </p>
              <ul>
                <li>Immediate disqualification from the referral program.</li>
                <li>Cancellation of pending or credited rewards.</li>
              </ul>
              <p>Drivolo reserves the right to verify all referrals.</p>

              <h2>6. Program Changes</h2>
              <p>Drivolo reserves the right to:</p>
              <ul>
                <li>Modify, suspend, or terminate the referral program at any time.</li>
                <li>Change reward amounts or eligibility criteria without prior notice.</li>
              </ul>

              <h2>7. Limitations</h2>
              <ul>
                <li>There is no limit on the number of referrals unless specified otherwise.</li>
                <li>Rewards are non-transferable and cannot be exchanged for cash unless stated.</li>
              </ul>

              <h2>8. Acceptance</h2>
              <p>
                By participating in the referral program, users agree to comply
                with these terms.
              </p>
              <p>
                For any queries, contact the{' '}
                <a href="mailto:Support@drivolo.com">Drivolo support team</a>.
              </p>
            </Box>
          </Grid>
        </Container>
      </Box>
    </Main>
  )
}

export default ReferralTerms
